import { NgbDateStruct } from '@cmps/ng-bootstrap';

export interface TdBuilderUsageMetricResult {
    resultSet: string;
    params: string;
    periods: string;
}

export interface TdBuilderUsageMetricUser {
    userId: number;
    userName: string;
}

export enum TdBuilderUsageMetricReportPopulationType {
    SuperGroup = '1',
    PeerGroup = '2',
    Individual = '3',
    RepsUnder = '4',
    Role = '5',
}

export interface TdBuilderUsageMetricReportSelectionParams {
    populationType: TdBuilderUsageMetricReportPopulationType;
    populationID: TdBuilderUsageMetricUser | string;
    defaultPopulationID: TdBuilderUsageMetricUser;
    startDate: NgbDateStruct;
    endDate: NgbDateStruct;
    invalidEndDate: boolean;
    invalidStartDate: boolean;
    pendingData: boolean;
    noData: boolean;
}

export interface TdBuilderUsageMetricReportResultParams {
    requestUserID: string;
    startDate: string;
    endDate: string;
    populationType: string;
    populationID: string;
    dateRequest: string;
}

export interface TdBuilderUsageMetricResultRow {
    userName: string;
    role: string;
    manager: string;
    superGroup: string;
    metric: string;
    timesGenerated: number;
}
